<template>
  <div>
    <a
      @click="loadRow()"
      data-toggle="modal"
      :data-target="target"
      href="#"
      class="name-btn"
      v-if="
        data &&
        options &&
        options.field &&
        data[options.field] &&
        options.field.length > 0
      "
    >
      <div class="computer-container">
        <div v-if="!exportStatus">
          <template v-if="options.subs">
            <div class="ag-tooltip">
              {{
                data[options.field]
                  .substring(
                    options.subs.split(",")[0],
                    options.subs.split(",")[1]
                  )
                  .toUpperCase()
              }}...
              <div class="top">
                {{ data[options.field] }}
                <i></i>
              </div>
            </div>
          </template>
          <div v-else>
            <ag-truncate
              v-if="options.truncate"
              :text="data[options.field]"
              :data="data"
              :options="options.truncate"
            ></ag-truncate>
            <span v-else>{{ data[options.field] }}</span>
          </div>
          <template v-if="options.append">
            <div v-html="options.append"></div>
          </template>
        </div>
        <div v-if="exportStatus">{{ data[options.field] }}</div>
      </div>
    </a>
    <div v-else>{{$t("noRecord")}}</div>
    <ag-copy-paste
      v-if="options.copyPaste"
      :text="data[options.field]"
    ></ag-copy-paste>
  </div>
</template>

<script>
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useStore } from "@/store";
import AgTruncate from "@/components/ag-truncate/index.vue";
import AgCopyPaste from "@/components/ag-copy-paste/index.vue";

const store = useStore();
export default {
  name: "tableModalComponent",
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
    target: {
      type: String,
      default: "#exampleModalCenter",
    },
  },
  methods: {
    loadRow() {
      if (
        this.options.selectedTab &&
        document.getElementById(this.options.selectedTab)
      ) {
        if (document.getElementById("ag-tab_overallview"))
          document.getElementById("ag-tab_overallview").click();

        setTimeout(() => {
          document.getElementById(this.options.selectedTab).click();
        }, 350);
      } else {
        setTimeout(() => {
          document.getElementById("ag-tab_endpoint").click();
        }, 350);
      }

      store.dispatch(GeneralActionTypes.SET_SELECTED_ROW, this.data);
    },
  },
  components: {
    AgTruncate,
    AgCopyPaste,
  },
  computed: {
    exportStatus() {
      return store.getters.exportStatus;
    },
  },
};
</script>

<style scoped>
.computer-container {
  display: flex;
}
</style>
